import { UpdateName } from "../components/UpdateName/UpdateName";

const UpdateNamePage = () => {
  return <UpdateName />;
};

export default UpdateNamePage;
